import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AdminAuthService } from '../services/admin-auth.service'

export const adminGuard: CanActivateFn = async () => {
  const router = inject(Router)
  const adminAuth = inject(AdminAuthService)

  const isAuthenticated = await adminAuth.checkAuth()
  if (isAuthenticated) return true

  router.navigate(['/vm-mh-admin-app'])
  return false
}
